import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    // Check if the icon exists in the LucideIcons object
    const IconComponent = name && typeof name === 'string' ? LucideIcons[name] : null;

    // If the icon doesn't exist, return a HelpCircle with a warning in development
    if (!IconComponent) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(`Icon "${name}" not found in lucide-react`);
        }
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}

export default Icon;